module.exports = __webpack_public_path__ + "img/11825380_L.d0498b3d.png";